import { render, staticRenderFns } from "./movimiento_NO_producto_Observacion.vue?vue&type=template&id=b8948a30"
import script from "./movimiento_NO_producto_Observacion.vue?vue&type=script&lang=js"
export * from "./movimiento_NO_producto_Observacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports